"use client";

import {
  Box,
  Container,
  Flex,
  Heading,
  Icon,
  Stack,
  Text,
} from "@chakra-ui/react";
import {
  FcAssistant,
  FcCollaboration,
  FcDepartment,
  FcFactory,
  FcHome,
  FcInspection,
  FcLibrary,
  FcShop,
} from "react-icons/fc";
import Layout from "../../../layout/Layout";
import { ApiCard } from "../../../components/card";

export default function AddressHome() {
  return (
    <Layout
      children={
        <Box p={4}>
          <Stack spacing={4} as={Container} maxW={"3xl"} textAlign={"center"}>
            <Heading fontSize={{ base: "2xl", sm: "4xl" }} fontWeight={"bold"}>
              Address APIs
            </Heading>
            <Text color={"gray.600"} fontSize={{ base: "sm", sm: "lg" }}>
              Extract precise address components and infer missing details to
              improve data quality
            </Text>
          </Stack>

          <Container maxW={"5xl"} mt={12}>
            <Flex flexWrap="wrap" gridGap={6} justify="center">
              <Box shadow={"lg"} borderRadius={"10"}>
                <ApiCard
                  heading={"Address Parsing"}
                  icon={<Icon as={FcDepartment} w={10} h={10} />}
                  description={"Extract address components with ease."}
                  href={"/address/address-parsing"}
                />
              </Box>
              <Box shadow={"lg"} borderRadius={"10"}>
                <ApiCard
                  heading={"Address Validation"}
                  icon={<Icon as={FcShop} w={10} h={10} />}
                  description={"Standardize and accurately complete addresses."}
                  href={"address/address-validation"}
                />
              </Box>
            </Flex>
          </Container>
        </Box>
      }
    />
  );
}
